import React from 'react';
import { Field } from '@atlaskit/form';
import Tooltip from '@atlaskit/tooltip';
import { type IntlShape, useIntl } from '@atlassian/jira-intl';
import { PriorityPicker } from '@atlassian/jira-priority-picker/src/index.tsx';
import type { FieldConfigurationComponentProps } from '../../../../types.tsx';
import type { AssociatedField } from '../../../../types/layout-items.tsx';
import { AkFieldWrapper, FieldConfigurationDefaultValue } from '../../styled.tsx';
import messages from './messages.tsx';

const onDefaultValueChange =
	(field: AssociatedField, onUpdate: (field: AssociatedField) => void) => (defaultValue?: string) =>
		onUpdate({
			...field,
			defaultValue: !defaultValue ? null : defaultValue,
		});

const refineDefaultValue = (defaultValue: unknown): string | undefined =>
	typeof defaultValue === 'string' ? defaultValue : undefined;

export const PriorityFieldConfiguration = ({
	field,
	projectId,
	onUpdate,
	tooltipDelay,
	testId,
}: FieldConfigurationComponentProps) => {
	const intl: IntlShape = useIntl();
	const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;
	return (
		<FieldConfigurationDefaultValue>
			<AkFieldWrapper>
				<Tooltip
					content={
						isModifyDefaultValueDisabled
							? intl.formatMessage(messages.priorityDefaultValueDisabledTooltip)
							: null
					}
					delay={tooltipDelay}
				>
					<Field
						name={`${field.key}-default-value`}
						label={intl.formatMessage(messages.priorityDefaultValueLabel)}
						testId={testId}
					>
						{({ fieldProps }) => (
							<PriorityPicker
								inputId={fieldProps.id}
								label={undefined}
								baseUrl=""
								isClearableWithCrossIcon
								noPortal
								// @ts-expect-error intl2 vs intl5
								intl={intl}
								value={refineDefaultValue(field.defaultValue)}
								isDisabled={isModifyDefaultValueDisabled}
								isRequired={false}
								projectIdOrKey={projectId}
								onChange={onDefaultValueChange(field, onUpdate)}
							/>
						)}
					</Field>
				</Tooltip>
			</AkFieldWrapper>
		</FieldConfigurationDefaultValue>
	);
};
